module.exports.app_id = "Curvit";

module.exports.api_url = "https://curvit-api.polymedia.nl";
module.exports.api_token = "4a5W589g84kTEFbK";

if(window.location.href.startsWith("http://localhost:3000/")) {
	module.exports.api_url = "http://localhost:3001";
	module.exports.api_token = "123";
}



// WEBPACK FOOTER //
// ./src/config.js